export const environment = {
  production: true,
  apiDomain: '',
  socketURL: '',
  redirectUrl: window.location.origin,
  module: 'ezy_flow',
};
